import EmailEntity, {
    EmailEntityType,
} from "@/domain/entities/emails/EmailEntity";
import { MailEntity } from "@cs_teamwaydev/mailvista-sdk_react";

const emailEntityMapper = (entity: MailEntity): EmailEntity => {
    if (
        !Object.values(EmailEntityType).includes(entity.type as EmailEntityType)
    ) {
        console.error(
            "Invalid entity type, change EmailEntityType to fix this error, or add the new type to the enum",
            entity.type,
        );
    }

    return new EmailEntity({
        type: entity.type as EmailEntityType,
        content: entity.content,
    });
};

export default emailEntityMapper;
